export default __webpack_public_path__ + "static/media/xml.d62348fb.svg";